// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgBusinessMiningSolid = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3.422 14.276c-.23.364-.777.23-.817-.22-.154-1.759.04-4.34 1.106-6.511a1 1 0 0 1 .046-1.365l2.12-2.121a1 1 0 0 1 1.34-.069c2.087-1.079 4.505-1.29 6.476-1.135.466.037.626.625.248.864-1.865 1.177-3.208 2.044-4.285 2.855a1 1 0 0 1-.243 1.02l-.353.354L20.742 19.63a.5.5 0 0 1 0 .707l-.707.707a.5.5 0 0 1-.707 0L7.646 9.362l-.354.353a1 1 0 0 1-1.006.248c-.81 1.084-1.681 2.438-2.864 4.313z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M20.563 4.757a3 3 0 0 1 0 4.243l-3.889 3.89a.5.5 0 0 1-.707 0l-1.414-1.415-2.402 2.402-1.414-1.415 2.402-2.401-1.414-1.414a.5.5 0 0 1 0-.708l3.889-3.889a3 3 0 0 1 4.242 0zM5.007 21.021a.5.5 0 0 1-.707 0l-.707-.707a.5.5 0 0 1 0-.707l6.437-6.438 1.414 1.414zm10.596-10.734 1.179-1.65a.5.5 0 0 0-.054-.644l-.108-.108a.5.5 0 0 0-.644-.053l-1.65 1.178a.5.5 0 0 0-.063.76l.58.58a.5.5 0 0 0 .76-.062z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgBusinessMiningSolid;
